export default "__VITE_ASSET__4e579335__"